import { ThemeEvents } from '@theme/events';

class AeyaShippingBar extends HTMLElement {
  connectedCallback() {
    this.goalCents = parseInt(this.dataset.aeyaFsbGoalCents ?? '0', 10) || 0;
    this.render(parseInt(this.dataset.aeyaFsbTotalCents ?? '0', 10) || 0);
    document.addEventListener(ThemeEvents.cartUpdate, this.onCartUpdate);
  }

  disconnectedCallback() {
    document.removeEventListener(ThemeEvents.cartUpdate, this.onCartUpdate);
  }

  onCartUpdate = () => {
    this.refresh();
  };

  async refresh() {
    try {
      const res = await fetch('/cart.js', {
        headers: { Accept: 'application/json' },
        credentials: 'same-origin',
      });
      if (!res.ok) return;
      const cart = await res.json();
      if (typeof cart.total_price === 'number') this.render(cart.total_price);
    } catch {
    }
  }

  render(totalCents) {
    const hasItems = totalCents > 0;
    this.classList.toggle('aeya-fsb--hidden', !hasItems);
    if (!hasItems) {
      this.style.setProperty('--aeya-fsb-progress', '0%');
      return;
    }
    if (this.goalCents <= 0) return;

    const pct = Math.min((totalCents / this.goalCents) * 100, 100);
    this.style.setProperty('--aeya-fsb-progress', `${pct}%`);
    this.classList.toggle('aeya-fsb--done', totalCents >= this.goalCents);
  }
}

if (!customElements.get('aeya-shipping-bar')) {
  customElements.define('aeya-shipping-bar', AeyaShippingBar);
}
